import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from './../assets/logo.webp';
import './styles/MobileNavBar.css';

import { useAuth } from "../context/AuthProvider";
import { useCart } from "../context/CartContext";
import { useStore } from "../context/StoreContext";

const MobileNavBar = () => {
  const { auth, logout } = useAuth();
  const { cart } = useCart();
  const { categories } = useStore();

  const [menuOpen, setMenuOpen] = useState(false);

  const cartItemCount = cart.reduce((total, item) => total + item.quantity, 0);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <div className="mobile-navbar">
      <div className="mobile-navbar-content-wrapper">
        <div className="mobile-navbar-header">
          <Link to="/" className="mobile-navbar-logo" onClick={() => setMenuOpen(false)}>
            <img src={logo} alt="Logo" width="180px" />
          </Link>

          {/* ✅ Animated Hamburger Button */}
          <div className="hamburger-container">
            <div
              className="hamburger-toggle"
              aria-label="Toggle menu"
              aria-expanded={menuOpen}
              aria-controls="main-menu"
              role="button"
              aria-pressed={menuOpen}
              onClick={toggleMenu}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && toggleMenu()}
              tabIndex={0}
            >
              <span className={`line top ${menuOpen ? 'open' : ''}`}></span>
              <span className={`line middle ${menuOpen ? 'open' : ''}`}></span>
              <span className={`line bottom ${menuOpen ? 'open' : ''}`}></span>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Mobile Menu */}
      {menuOpen && (
        <nav className="mobile-navbar-menu">
          {/* ✅ Icons (Login/Signup + Cart) in top-right of menu */}
          <div className="mobile-navbar-menu-icons">

            {auth.isAuthenticated ? (
              <div className='mobile-user-wrapper'>

                <NavLink to="/user/profile" className="mobile-navbar-icon" onClick={() => setMenuOpen(false)}>
                  <i className="fa-solid fa-user"></i>
                </NavLink>
                <button onClick={logout} className="mobile-navbar-icon logout-button">
                  <i className="fa-solid fa-right-from-bracket"></i>
                </button>
              </div>
            ) : (
              <>
                <NavLink to="/login" className="mobile-navbar-icon" onClick={() => setMenuOpen(false)}>
                  <i className="fa-solid fa-user"></i>
                </NavLink>
              </>
            )}
            <NavLink to="/shopping-cart" className="mobile-navbar-icon cart-link" onClick={() => setMenuOpen(false)}>
              <i className="fa-solid fa-cart-shopping"></i>
              {cartItemCount > 0 && <span className="cart-count">{cartItemCount}</span>}
            </NavLink>
          </div>

          <div className="mobile-navbar-group">
            <span className="mobile-navbar-title">Shop Knives</span>
            <NavLink to="/shop-knives/all-knives" className="mobile-navbar-link" onClick={() => setMenuOpen(false)}>
              All Products
            </NavLink>
            {categories.map((category) => (
              <NavLink
                key={category.id}
                to={`/shop-knives/category/${category.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="mobile-navbar-link"
                onClick={() => setMenuOpen(false)}
              >
                {category.name}
              </NavLink>
            ))}
          </div>

          <div className="mobile-navbar-group">
            <span className="mobile-navbar-title">Info</span>
            <NavLink to="/about" className="mobile-navbar-link" onClick={() => setMenuOpen(false)}>
              About Us
            </NavLink>
            <NavLink to="/our-process" className="mobile-navbar-link" onClick={() => setMenuOpen(false)}>
              Our Process
            </NavLink>
            <NavLink to="/shipping-returns" className="mobile-navbar-link" onClick={() => setMenuOpen(false)}>
              Shipping & Returns
            </NavLink>
            <NavLink to="/privacy-policy" className="mobile-navbar-link" onClick={() => setMenuOpen(false)}>
              Privacy Policy
            </NavLink>
          </div>

          <NavLink to="/contact" className="mobile-navbar-link" onClick={() => setMenuOpen(false)}>
            Contact Us
          </NavLink>

          {auth.isAuthenticated && ["admin", "siteadmin"].includes(auth.user?.role) && (
            <NavLink to="/admin/dashboard" className="mobile-navbar-link" onClick={() => setMenuOpen(false)}>
              Admin
            </NavLink>
          )}
        </nav>
      )}
      
    </div>
  );
};

export default MobileNavBar;
